import type { FC } from "react";

import { styled } from "styled-components";

import { SWReactCountryIcons } from "@similarweb/icons";

import type {
    ILanguageLocaleAndDescription,
    IGeoLocation,
} from "../../../reports/shared/Table/TableUtils/RankTrackerTablesTypes";
import { RankTrackerTooltip } from "app/components/campaigns/shared/RankTrackerTooltip";

type LocationIconProps = {
    geoLocation: IGeoLocation | ILanguageLocaleAndDescription;
};

const StyledIcon = styled(SWReactCountryIcons)`
    margin-left: 8px;
`;

export const LocationIcon: FC<LocationIconProps> = ({ geoLocation }) => {
    if (!geoLocation?.countryCode) {
        return null;
    }

    return (
        <RankTrackerTooltip content={geoLocation.text}>
            <StyledIcon
                countryCode={geoLocation.countryCode}
                size="xs"
            />
        </RankTrackerTooltip>
    );
};
